<template>
    <div>All cars</div>
</template>
<script>
export default {
  name: 'AllCars'
}
</script>
